import React from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import styled from 'styled-components'
import { animations } from '../animations'
import { Button, Overlay } from '../Blocks';

const Modal = ({ maxW = "400px", gap = "30px", padding = "30px", bg = "var(--modal-background)", children, motion }) => {

    return (
        <Overlay id="modals" motion={animations.fadeIn("spring", .2)}>
            <Wrap $maxW={maxW} $padding={padding} $gap={gap} $bg={bg}  {...motion} >{children}</Wrap>
        </Overlay>
    )


}


export default Modal




const Wrap = styled(motion.div)`
    z-index: 101;
    width: 100%;
    max-width: ${(props) => (props.$maxW)};
    height: fit-content;
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${(props) => (props.$bg) ? props.$bg : "white"}; 
    border-radius: 6px;
    flex-direction: column;
    gap: ${(props) => (props.$gap)};
    padding: ${(props) => (props.$padding)};
    filter: drop-shadow(0 2px 8px #88888888);
    outline: 1px solid #88888888;
    background: ${(props) => (props.$bg)};

    
    @media(prefers-color-scheme: dark) {
        filter: drop-shadow(0 2px 8px #88888888);
        
          }
    
    @media(width > 768px) {
        padding: 30px;
        }
        `
